import React from 'react'
import { BgImage } from 'gbimage-bridge'
import * as styles from './index.module.css'

const IconInfoList = ({ title, components }) => {
  return (
    <div className="wrapper">
      <div className={styles.container}>
        <h2>{title}</h2>
        <div className={styles.collection}>
          {components.map((item, idx) => (
            <div className={styles.item} key={idx}>
              <div className={styles.imageContainer}>
                {item.image != null && (
                  <BgImage
                    image={item.image.gatsbyImageData}
                    className={styles.backgroundImage}
                  />
                )}
              </div>
              <h4>{item.title}</h4>
              <span>{item.subtitle.subtitle}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default IconInfoList
